import { useContext } from 'react'

import { ModalContext, SidebarModal, Text } from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import useOrderItem from '@hooks/useOrderItem'

import buildOptionsString, { buildItemTitle } from '@functions/orderItem'

import ManageArtwork from './components/ManageArtwork'

const MODAL_KEY = 'ManageBrandOrderArtworkModal'

type ModalCallbacks = {
  closeModal: () => void,
}

type ModalProps = {
  callbacks: ModalCallbacks,
  showModal: boolean,
}

const ManageBrandOrderArtworkModal = (props: ModalProps) => {
  const { callbacks, showModal } = props

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = digObject(modalData, MODAL_KEY, {})
  const { orderItem: initOrderItem } = modalPayload

  const orderItemPayload = useOrderItem(initOrderItem)
  const { orderItem: { options } } = orderItemPayload

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={MODAL_KEY} showModal={showModal}>
      <SidebarModal.Header callbacks={callbacks} title="Manage" titleSecondLine="Artwork" />

      <SidebarModal.SubHeader
        boxProps={{
          flexDirection: 'column', justifyContent: 'center', alignItems: 'start',
        }}
      >
        <Text fontSize="small">
          {buildItemTitle({ orderableItem: initOrderItem, excludeOptionsString: true })}
        </Text>

        <Text color="bodyFontLightColor" fontSize="xsmall" lineHeight="1.3" marginTop="small">
          {/*
           // @ts-expect-error TS2345 */}
          {buildOptionsString(options)}
        </Text>
      </SidebarModal.SubHeader>

      <SidebarModal.Content>
        <ManageArtwork orderItemPayload={orderItemPayload} />
      </SidebarModal.Content>
    </SidebarModal>
  )
}

const LazyLoadedModal = (props: ModalProps) => (
  <SidebarModal.RenderController {...props}>
    <ManageBrandOrderArtworkModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
